import { Observable } from 'rxjs';

// A workaround class which can be used in RxJS 5 and RxJS 6
export class ObservableWorkaround {
  public static of<T, T2, T3, T4>(a: T, b: T2 = undefined, c: T3 = undefined, d: T4 = undefined): Observable<T | T2 | T3 | T4> {
    return new Observable((subscriber) => {
      subscriber.next(a);
      if (b !== undefined) {
        subscriber.next(b);
      }
      if (c !== undefined) {
        subscriber.next(b);
      }
      if (d !== undefined) {
        subscriber.next(b);
      }
      subscriber.complete();
    });
  }

  public static throw(error: any): Observable<never> {
    return new Observable((subscriber) => subscriber.error(error));
  }

  public static fromEvent(nativeElement: any, eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      nativeElement.addEventListener(eventName, (value) => {
        subscriber.next(value);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/observable-workaround.class.ts